// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workspace-picker {
  background-color: #ffffff;
  border: 1px solid black;
  border-radius: 0.3rem;
  overflow-y: scroll;
  min-height: 30vh;
  height: 30vh;
}`, "",{"version":3,"sources":["webpack://./src/Screens/Step3/Step3.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACF,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AACA","sourcesContent":[".workspace-picker{\n  background-color: #ffffff;\nborder: 1px solid black;\nborder-radius: 0.3rem;\noverflow-y: scroll;\nmin-height: 30vh;\nheight: 30vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
